import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import { CloseXIcon } from "../ChatiaIcons";

const ExpandIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 10L21 3M21 3H15M21 3V9" />
    <path d="M10 14L3 21M3 21H9M3 21V15" />
  </svg>
);

// Scroll grudado no canto direito (sem border-radius, fino)
const edgeScrollbar = (theme) => ({
  "&::-webkit-scrollbar": {
    width: 5,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.15)" : "rgba(255,255,255,0.15)",
    borderRadius: 0,
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.25)" : "rgba(255,255,255,0.25)",
    },
  },
  "&::-webkit-scrollbar-button": {
    display: "none",
  },
  scrollbarWidth: "thin",
  scrollbarColor: theme.mode === "light"
    ? "rgba(0,0,0,0.15) transparent"
    : "rgba(255,255,255,0.15) transparent",
});

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: "relative",
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      paddingRight: 0,
    },
    "& textarea": {
      ...edgeScrollbar(theme),
      paddingRight: 12,
    },
  },
  expandBtn: {
    position: "absolute",
    top: 12,
    right: 5,
    zIndex: 1,
    width: 26,
    height: 26,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: 8,
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    },
  },
  fullScreenPaper: {
    borderRadius: "12px !important",
    maxHeight: "90vh !important",
    width: "95vw",
    maxWidth: "800px !important",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  fullScreenHeader: {
    ...theme.chatiaDS.header,
    flexShrink: 0,
  },
  fullScreenTitle: {
    ...theme.chatiaDS.headerTitle,
  },
  closeButton: {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    color: "#ffffff",
    transition: "all 0.2s ease",
  },
  fullScreenContent: {
    padding: "16px !important",
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      flex: 1,
      alignItems: "flex-start",
      paddingRight: 0,
    },
    "& textarea": {
      ...edgeScrollbar(theme),
      paddingRight: 12,
      height: "100% !important",
      overflow: "auto !important",
    },
  },
}));

const ChatiaPromptField = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 6,
  helperText,
  extraContent,
  ...textFieldProps
}) => {
  const classes = useStyles();
  const [fullScreen, setFullScreen] = useState(false);

  return (
    <>
      <div className={classes.wrapper}>
        <IconButton
          className={classes.expandBtn}
          onClick={() => setFullScreen(true)}
          title="Expandir"
          size="small"
        >
          <ExpandIcon />
        </IconButton>
        <TextField
          label={label}
          multiline
          rows={rows}
          fullWidth
          variant="outlined"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          helperText={helperText}
          {...textFieldProps}
        />
      </div>

      <Dialog
        open={fullScreen}
        onClose={() => setFullScreen(false)}
        maxWidth={false}
        PaperProps={{ className: classes.fullScreenPaper }}
      >
        <div className={classes.fullScreenHeader}>
          <Typography className={classes.fullScreenTitle}>
            {label || "Prompt"}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setFullScreen(false)}
            className={classes.closeButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.18)";
              e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
              e.currentTarget.style.color = "#ffffff";
            }}
          >
            <CloseXIcon style={{ fontSize: 18 }} />
          </IconButton>
        </div>
        <DialogContent className={classes.fullScreenContent}>
          <TextField
            multiline
            fullWidth
            variant="outlined"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            InputProps={{
              style: { fontFamily: "monospace", fontSize: 13, lineHeight: 1.6 },
            }}
            style={{ flex: 1 }}
            rows={25}
          />
          {extraContent && (
            <div style={{ paddingTop: 12, flexShrink: 0 }}>
              {extraContent}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChatiaPromptField;
